import classes from "./DrinkReferenceLine.module.css";

// component for each drink line in contents page
const DrinkReferenceLine = (props) => {
  const drink = props.drink;

  return (
    <div className={classes.drink_line}>
      <div className={classes.page_num}>{props.pageNum}.</div>
      <div className={classes.title}>{drink.title}</div>
      <div className={classes.quantity}>{drink.amount}</div>
    </div>
  );
};

export default DrinkReferenceLine;
